<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>

<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="my-1">
        <button class="btn btl-rounded btn-primary" type="button" [routerLink]="['/postulantes/form']">Crear
          Postulante</button>
      </div>
      <table class="table table-responsive table-striped table-bordered table-light table-sm table-hover">
        <thead>
          <tr>
            <th>id</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Interes</th>
            <th>Turno</th>
            <th>Promotion</th>
            <th>Favoritos</th>
            <th>Acciones</th>
          </tr>

        </thead>
        <tbody>
          <tr *ngFor="let postulante of postulantes">
            <td>{{postulante.id}}</td>
            <td>{{postulante.name}}</td>
            <td>{{postulante.email}}</td>
            <td>{{postulante.phone}}</td>
            <td>{{postulante.interes}}</td>
            <td>{{postulante.turno}}</td>
            <td>{{postulante.promotion}}</td>
            <td><span class="badge badge-info">{{postulante.favoritos.length}}</span></td>
            <td><button class="btn btn-primary btn-sm" routerLink="/postulantes/form/{{postulante.id}}">Actualizar</button></td>
            <td><button class="btn btn-primary btn-sm" routerLink="/postulantes/formnested/{{postulante.id}}">Actualizar Nested</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12">
      <button class="btn btn-danger my-3" type="button" routerLink="/postulantes/formreactivo">Form Reactivo Postulante</button>
    </div>
    <div class="col-md-12">
      <button class="btn btn-danger my-3" type="button" routerLink="/productos/formreactivo">Form Reactivo Producto</button>
    </div>
    <div class="col-md-12">
      <button class="btn btn-danger" type="button" routerLink="/productos/formreactivodinamico">Form Reactivo Producto Dinámico</button>
    </div>
    <div class="col-md-12">
      <button class="btn btn-danger" type="button" routerLink="/postulantes/formnested">Form Postulante Nested</button>
    </div>
  </div>
</div>